import { GET } from '@/api';
import CONST from '@/utils/Constants/General';

const URL = '/recipe/facet';
const URL_BY_PRODUCT = '/recipe/h_facets';

export default async ({ facetCode, q, config, successCB, failCB }) => {
  try {
    const urlPrefix =
      facetCode === CONST.RECIPE.FACET.PRODUCTS
        ? URL_BY_PRODUCT
        : `${URL}/${facetCode}`;
    const formattedUrl = `${urlPrefix}${q ? `?q=${q}` : ''}`;
    const { data } = await GET(formattedUrl, config);
    return (typeof successCB === 'function' && successCB(data)) || data;
  } catch (e) {
    return (typeof failCB === 'function' && failCB(e)) || e;
  }
};
